import * as React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"

const LinkButton = ({ text, url, className }) => {
  return (
    <Link
      to={url}
      className={`text-white text-base w-52 font-bold bg-brandNavy rounded pt-3 pb-3 text-center tracking-widest pl-2 pr-2 hover:opacity-90 block ${className}`}
    >
      {text}
    </Link>
  )
}

LinkButton.propTypes = {
  text: PropTypes.string.isRequired,
  url: PropTypes.string,
  className: PropTypes.string,
}

export default LinkButton
